import React from 'react'

declare global {
  interface Window {
    googletag: any;
  }
}

function AdDebug() {
  return (    
      <React.Fragment>
        {
          (process.env.NEXT_PUBLIC_APP_ENV != "production") &&
            <div>
              <button className="teasers__more__btn btn btn-primary" onClick={(e) => {e.preventDefault();window.googletag.openConsole()}}>Enable googletag openConsole()</button>
            </div>
          }
      </React.Fragment>
    )
}

export default AdDebug

